<template>
  <div>
    Trends
  </div>
</template>

<script>
export default {
  name: 'Trends'
}
</script>

<style>

</style>